"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isStagingEnvironment = exports.isProductionEnvironment = exports.isLocalEnvironment = exports.getEnvironment = exports.ENVIRONMENTS = void 0;

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ENVIRONMENTS = {
  LOCAL: 'local',
  STAGING: 'staging',
  PRODUCTION: 'production'
};
/**
 * @param  {object} windowParam - optional window object
 *
 * @return {string} Will return the current  environment 
 * where the code is executed (either 'local', 'staging', or 'production')
 */

exports.ENVIRONMENTS = ENVIRONMENTS;

var getEnvironment = function getEnvironment() {
  var _window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

  if ((0, _lodash["default"])(_window, 'view.STAGING')) {
    return ENVIRONMENTS.STAGING;
  } else if ((0, _lodash["default"])(_window, 'view.PRODUCTION')) {
    return ENVIRONMENTS.PRODUCTION;
  }

  return ENVIRONMENTS.LOCAL;
};
/**
 * Internal function used to check if the current environment
 * matches the environment given as a parameter
 * @param  {string} environment - environment to check
 *
 * @return {boolean} boolean indicating if it matches environment or not
 */


exports.getEnvironment = getEnvironment;

var isWindowEnvironmentEqualTo = function isWindowEnvironmentEqualTo(environment) {
  var windowParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  return getEnvironment(windowParam) === environment;
};
/**
 * Function used to check if the current environment
 * is a local (development) environment
 * @param  {object} windowParam - optional window object
 *
 * @return {boolean} boolean indicating if it's a local environment
 */


var isLocalEnvironment = function isLocalEnvironment() {
  var windowParam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  return isWindowEnvironmentEqualTo(ENVIRONMENTS.LOCAL, windowParam);
};
/**
 * Function used to check if the current environment
 * is a staging environment
 * @param  {object} windowParam - optional window object
 *
 * @return {boolean} boolean indicating if it's a staging environment
 */


exports.isLocalEnvironment = isLocalEnvironment;

var isStagingEnvironment = function isStagingEnvironment() {
  var windowParam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  return isWindowEnvironmentEqualTo(ENVIRONMENTS.STAGING, windowParam);
};
/**
 * Function used to check if the current environment
 * is a production environment
 * @param  {object} windowParam - optional window object
 *
 * @return {boolean} boolean indicating if it's a production environment
 */


exports.isStagingEnvironment = isStagingEnvironment;

var isProductionEnvironment = function isProductionEnvironment() {
  var windowParam = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  return isWindowEnvironmentEqualTo(ENVIRONMENTS.PRODUCTION, windowParam);
};

exports.isProductionEnvironment = isProductionEnvironment;